/* eslint-disable global-require */
module.exports = ['common.modaltour.btn1', 'common.modaltour.btn2', ...require('./Navigation/i18n')];
